export default "__VITE_ASSET__BHKE0dD8__"